// Angular
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

// Services
import { LoginService } from 'src/app/services/login/login.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessagesService } from 'src/app/services/message/messages.service';

// Class
import { Admin } from '../../shared/classes';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.less']
})
export class LoginComponent implements OnInit {
  public loginForm;
  public year = new Date().getFullYear();

  constructor(private fb: FormBuilder, private login: LoginService, private router: Router, private msg: MessagesService,
    private load: NgxSpinnerService) { }

  ngOnInit() {
    this.initForm();
  }

  // inits the form
  private initForm() {
    this.loginForm = this.fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });
  }

  // submit form and login platform admin
  public submitLogin() {
    // load spinner
    this.load.show();
    // get admin details
    const username = this.loginForm.value.username;
    const password = this.loginForm.value.password;

    const adminUser = new Admin(username, password);

    this.login.loginAdmin(adminUser)
      .then(accessMessage => {
        this.load.hide();
        this.msg.success(accessMessage);
        this.msg.info('Redirecting user shortly');
        setTimeout(() => {
          this.router.navigate(['/dashboard']);
        }, 2000);
      })
      .catch(error => {
        this.load.hide();
        this.msg.error(error);
      });
  }
}
